"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Picture = ({
  value,
  fetched,
  fetching,
  format
}) => {
  if (value) {
    switch (format) {
      case 'base64':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: 'avatar-wrapper-small'
        }, /*#__PURE__*/_react.default.createElement("span", {
          alt: "",
          className: 'avatar-round avatar-user',
          style: {
            backgroundImage: `url(data:image/png;base64,${value})`
          }
        }));
      default:
        return /*#__PURE__*/_react.default.createElement("div", null, "Image");
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'avatar-wrapper-small'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'avatar-round avatar-user'
  }));
};
var _default = exports.default = Picture;
module.exports = exports.default;